// extracted by mini-css-extract-plugin
export var container = "_39-0";
export var error = "_39-9";
export var label = "_39-5";
export var light = "_39-6";
export var md = "_39-3";
export var sm = "_39-2";
export var thin = "_39-8";
export var thinBold = "_39-7";
export var vertical = "_39-4";
export var xs = "_39-1";